import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../shared/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FuseMainModule } from '@ecap3/template-atlas';
import { NgxPullToRefreshModule } from '../shared/stubs/other-stubs.module';

import { RootDefaultComponent } from './root-default/root-default.component';
import { Unauthorized } from './unauthorized/unauthorized.component';
import { NotFoundSiteDomainComponent } from './site-domain/site-domain.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { FuseModule } from '../fuse/fuse.module';

@NgModule({
    declarations: [
        RootDefaultComponent,
        Unauthorized,
        NotFoundSiteDomainComponent,
        NotFoundComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        TranslateModule.forChild(),
        FuseMainModule,
        NgxPullToRefreshModule,
        FuseModule
    ],
    exports: [
        RootDefaultComponent,
        Unauthorized,
        NotFoundSiteDomainComponent,
        NotFoundComponent
    ]
})
export class RootComponentsModule { }
